<template>
  <div>
    <div
      class="bg-fixed"
      :class="{'bg_i6_tp': isThaiCharoenPlus, 'bg_i6_sc': isSevenColor, 'bg_i6_ts': isThaisiam, 'bg_i6_hp': isHuaypromt, 'bg_i6_jj': isJertjarat, 'bg_i6_ls': isLottoslot88, 'bg_i6_cc': isChokCharoen, 'bg_i6_bc': isBooncharern, 'bg_i6': isDefaultSite}"
    ></div>
    <div class="py-5">
      <div class="container">
        <div
          class="row justify-center align-items-center position-relative"
          style="z-index: 1"
        >
          <LogoHeader />
          <!-- <LogoHeader /> -->
        </div>

        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div>
              <div class="bg_c15 p-4 p-md-5 bdr-20">
                <h1
                  class="t-medium animateMe animated fadeInUp theme-main-text"
                  data-animation="fadeInUp"
                >
                  ลืมรหัสผ่าน
                </h1>

                <p
                  class="mt-2 animateMe animated fadeInUp theme-main-text"
                  data-animation="fadeInUp"
                >
                  <small 
                    class="bg_c16 c-white px-2 bdr-5"
                  >STEP 1</small> ระบบจะทำการรีเซ็ทรหัสผ่านเป็นหมายเลขบัญชีที่เชื่อมกับเบอร์โทร
                </p>

                <form
                  class="mt-4"
                  @submit.prevent=""
                >
                  <!-- <div
                    class="box_shadow bg_c9 p-2 bdr-10 animateMe animated fadeInUp"
                    data-animation="fadeInUp"
                  >
                    <input
                      v-model="username"
                      type="text"
                      class="form-control border-0"
                      placeholder="ชื่อผู้ใช้"
                      :disabled="!!countDown"
                    />
                  </div> -->
                  <div class="box_shadow bg_c9 p-2 bdr-10 mt-4 animateMe animated fadeInUp">
                    <input
                      v-model="phoneNumber"
                      type="text"
                      maxlength="10"
                      class="form-control border-0"
                      placeholder="เบอร์โทรศัพท์"
                      :disabled="!!countDown"
                      @input="onInputChange"
                    >
                  </div>
                  <div class=" bdr-10 mt-4 ">
                    <button
                      class="button-main bdr-20 bg_c2 c-white mb-3 animateMe animated fadeInUp"
                      data-animation=""
                      :disabled="$v.phoneNumber.$invalid"
                      @click="requiredVerifyCode"
                    >
                      รีเซ็ทรหัสผ่าน
                      <span
                        v-if="countDown"
                        class="pl-2"
                      >
                        ({{ countDown }}s)
                      </span>
                    </button>
                  </div>
                  
                  <div v-if="state == STATE_2_AFTER_REQUEST_OTP">
                    <div
                      class="line-between my-4 animateMe animated fadeInUp"
                      data-animation="fadeInUp"
                    ></div>

                    <div class="box_shadow bg_c9 p-2 bdr-10 position-relative animateMe animated fadeInUp">
                      <input
                        v-model="otp"
                        type="text"
                        class="form-control border-0"
                        placeholder="รหัสยืนยัน OTP"
                      >
                    </div>
                    <div class="box_shadow bg_c9 p-2 bdr-10 mt-4 animateMe animated fadeInUp">
                      <input
                        v-model="newPassword"
                        type="password"
                        class="form-control border-0"
                        placeholder="รหัสผ่านใหม่"
                      />
                    </div>
                    <div class="box_shadow bg_c9 p-2 bdr-10 mt-4 animateMe animated fadeInUp">
                      <input
                        v-model="confirmNewPassword"
                        type="password"
                        class="form-control border-0"
                        placeholder="ยืนยันรหัสผ่านใหม่"
                      />
                    </div>
                    <div class="mt-4">
                      <button
                        class="button-main bdr-20 bg_c2 c-white mb-3 animateMe animated fadeInUp"
                        data-animation="fadeInUp"
                        :disabled="$v.$invalid"
                        @click="resetPassword"
                      >
                        ยืนยัน
                      </button>
                    </div>
                  </div>
                </form>

                <div class="pb-10 mb-5"></div>
              </div>

              <div class="position-relative px-2 px-md-5 pt-4">
                <div
                  class="position-absolute top-0 start-50 translate-middle"
                  style="width: 70%"
                >
                  <router-link
                    :to="{ name: ROUTE_INDEX }"
                    class="button-main bdr-20 bg_c3 border-0 c-white animateMe"
                    :class="{'bg_c3_bc': isBooncharern}"
                    data-animation="fadeInUp"
                  >
                    <i class="fas fa-chevron-left me-2"></i>กลับสู่หน้าแรก
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate' 
import { auth as apiAuth } from '@/apis'
import { ROUTE_V3_LOGIN, ROUTE_INDEX } from '@/const/route'
import * as c from '@/const/setTimeOutConfig'
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import LogoHeader from '@/components/Page/LogoHeader'

export const STATE_1_BEFOR_REQUEST_OTP = 1
export const STATE_2_AFTER_REQUEST_OTP = 2

export default {
  components: {
    LogoHeader
  },
  mixins: [validationMixin],
  data () {
    return {
      ROUTE_INDEX,
      STATE_1_BEFOR_REQUEST_OTP,
      STATE_2_AFTER_REQUEST_OTP,
      state: STATE_1_BEFOR_REQUEST_OTP,
      username: '',
      phoneNumber: '',
      verify: {},
      otp: '',
      newPassword: '',
      confirmNewPassword: '',
      countDown: 0,
    };
  },
  validations: {
    phoneNumber: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    // otp: {
    //   required,
    // },
    // username: {
    //   required,
    // },
    // newPassword: {
    //   required,
    // },
    // confirmNewPassword: {
    //   required,
    // },
  },
  methods: {
    onInputChange (event) {
      this.phoneNumber = event.target.value.replace(/\D/g, '');
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
        }, 1000)
      }
    },
    async requiredVerifyCode () {
      if (this.$v.phoneNumber.$invalid) {
        return;
      }

      var params = {
        // username: this.username,
        phone: this.phoneNumber,
        domain: window.location.host
      }

      const [err, data] = await apiAuth.requestOTPResetPasswordDefault(params)
      
      if (err) {
        this.$alert('', err, 'warning')
        return
      }

      this.$alert(`รหัสผ่านของคุณถูกรีเซ็ทเป็น หมายเลขบัญชี ${data.bank_number} ที่เชื่อมกับเบอร์โทรของคุณเรียบร้อย`, 'รีเซ็ทรหัสผ่านเรียบร้อยแล้ว', 'success').then(() => {
        this.$router.push({
          name: ROUTE_V3_LOGIN
        })
      });

      this.verify = data

      // this.state = STATE_2_AFTER_REQUEST_OTP
      // this.countDown = 15
      // this.countDownTimer()
    },
    async resetPassword () {
      if (this.$v.$invalid) {
        return;
      }

      const params = {
        uuid: this.verify.user_uuid,
        ref: this.verify.ref,
        password: this.otp,
        new_password: this.newPassword,
        password_confirmation : this.confirmNewPassword
      }

      const [err, , message] = await apiAuth.verifyOTPResetPassword(params)
      
      if(err) { 
        this.$alert('', err, 'warning')
        return
      } 

      this.$alert('', message, 'success')

      setTimeout(() => { 
        this.$router.push({
          name: ROUTE_V3_LOGIN
        }).catch(() => {});
      },
      c.DELAYREDIRECTPAGE)   
    }
  }
};
</script>

<style scoped>
.button-main {
  width: 100%;
}
button:disabled {
  background: var(--v3-base-color-10);
}

.bg_c3_bc {
  background: linear-gradient(90deg, var(--v3-btn-login-color-20) 0%, var( --v3-btn-login-color-20-end) 100%) !important;
}
</style>
